import { isMobile } from 'utils/is-mobile';
import './skeleton.less';
import { SkeletonButton } from 'newcomponents/UI/Skeleton/Button';
import '../../index.less';
import '../../skeleton.less';

export const ProvidersSliderHeaderSkeleton = () => {
  return (
    <div className="providersSlider__header providersSlider__header__skeleton">
      <div className="providersSlider__header__title">
        <SkeletonButton style={{ width: '100px', height: '24px' }} />
        {isMobile() ? (
          <SkeletonButton
            style={{ width: '24px', height: '24px', minWidth: 'unset' }}
          />
        ) : null}
      </div>
      <div className="providersSlider__header__actions">
        {isMobile() ? (
          <SkeletonButton
            style={{ width: '28px', height: '28px', minWidth: 'unset' }}
          />
        ) : (
          <>
            <SkeletonButton style={{ width: '80px', height: '40px' }} />

            <SkeletonButton
              style={{ width: '320px', height: '40px', marginRight: '12px' }}
            />

            <div className="providersSlider__arrows">
              <SkeletonButton
                style={{
                  width: '40px',
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '24px'
                }}
              />
              <SkeletonButton
                style={{
                  width: '40px',
                  minWidth: '40px',
                  height: '40px',
                  borderRadius: '24px'
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
